<header aria-label="Site header" class="header">
  <nav class="header-container wrapper">

    <a href="https://n-somerset.gov.uk/" class="logo">
      <img src="assets/images/n-somerset-logo.svg" alt="North Somerset Site Logo">
    </a>

    <button class="expand collapsed mobile-only" type="button" data-bs-toggle="collapse"
      data-bs-target="#servicesCollapse" aria-expanded="false" aria-controls="servicesCollapse"
      aria-label="toggle navigation menu">
    </button>

    <nav class="header-nav desktop-only">
      <ul>
        <li>
          <a href="https://n-somerset.gov.uk/my-services">Services</a>
        </li>
        <li>
          <a href="https://n-somerset.gov.uk/business">Business</a>
        </li>
        <li>
          <a href="https://n-somerset.gov.uk/council-democracy">My council</a>
        </li>
        <li>
          <a href="https://n-somerset.gov.uk/do-it-online">Do it online</a>
        </li>
        <li>
          <a href="https://n-somerset.gov.uk/contact-us">Contact us</a>
        </li>
        <li>
          <a href="https://n-somerset.gov.uk/news ">News</a>
        </li>
      </ul>
    </nav>

  </nav>

  <nav class="mobile-nav collapse mobile-only" id="servicesCollapse">
    <ul>
      <li><a href="https://n-somerset.gov.uk/my-services">Services</a>
      </li>
      <li><a href="https://n-somerset.gov.uk/business">Business</a></li>
      <li><a href="https://n-somerset.gov.uk/council-democracy">My council</a></li>
      <li><a href="https://n-somerset.gov.uk/do-it-online">Do it online</a>
      </li>
      <li><a href="https://n-somerset.gov.uk/contact-us">Contact us</a></li>
      <li><a href="https://n-somerset.gov.uk/news">Help</a></li>
    </ul>
  </nav>

  <div class="search-bar">
    <form class="search-form" (ngSubmit)="search()">
      <input [(ngModel)]="searchValue" name="searchValue" class="form-control search-input" type="search"
        placeholder="What are you looking for?" aria-label="Search input" />
      <button class="search-button">
        Search
      </button>
    </form>

  </div>
</header>